import { Outlet } from "react-router-dom";
import "./MainLayout.css";
import ContactButton from "./components/ContactButton";
import Header from "./components/Header";
import Sidebar from "./components/SideBar";
import { useSidebarLayout } from "../../contexts/SidebarLayoutContext";

const MainLayout = () => {
  const { hasSidebar } = useSidebarLayout();

  return (
    <div className="h-screen flex flex-col bg-[#f8f9fd] overflow-hidden">
      <Header />

      <div className="flex flex-1 min-h-0 min-w-0">
        {hasSidebar && <Sidebar />}

        <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto p-4 sm:p-8">
            <Outlet />
          </div>

          <ContactButton />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
